export default __webpack_public_path__ + "static/media/JAS0190.34I-43401_-25960_15.b1614929.jpg";